import React from "react";

// import { getRequestParams } from 'tools/utils/index';
// const InviteNew = React.lazy(() => import( './InviteNew/index' /* webpackChunkName:"InviteNew" */ ));
const NotFound = React.lazy(() => import( 'commons/NotFound/index' /* webpackChunkName:"NotFound" */ ));
const CommonPage = React.lazy(() => import('./Common/index' /* webpackChunkName:"Common" */));
const CommonLogin = React.lazy(() => import('./CommonLogin/index' /* webpackChunkName:"CommonLogin" */));
const FamilySecurity = React.lazy(() => import('./FamilySecurity/index' /* webpackChunkName:"FamilySecurity" */));
const HuiMinBao = React.lazy(() => import('./HuiMinBao/index' /* webpackChunkName:"HuiMinBao" */));
const Recruit = React.lazy(() => import('./Recruit/index' /* webpackChunkName:"Recruit" */));
const Coupon = React.lazy(() => import('./Coupon' /* webpackChunkName:"Coupon" */));
const RecruitAgent = React.lazy(() => import('./RecruitAgent' /* webpackChunkName:"RecruitAgent" */));
const SignWechat = React.lazy(() => import('./SignWechat' /* webpackChunkName:"SignWechat" */));
const Hkxjk = React.lazy(() => import('./Hkxjk' /* webpackChunkName:"Hkxjk" */));

const routers = [
    {
        path: '/commonLogin/:actId',
        component: CommonLogin,
        point: { event_id: "2241951", pageId: 'H1008'}
    },{
        path: '/inviteNew/:actId', // 代理人招募活动页
        component: RecruitAgent,
        point: { event_id: "2241951", pageId: 'H1008'}
    },{
        path: '/familySecurity/:actId',
        component: FamilySecurity,
        point: { event_id: "2241951", pageId: 'H1008'}
    },{
        path: '/notFound',
        component: NotFound,
    }, {
        path: '/common/:actId',
        component: CommonPage,
        point: { event_id: "2241951", pageId: 'H1005'}
    }, {
        path: '/hmb/:actId',
        component: HuiMinBao,
        point: { event_id: "2241951", pageId: 'H1005'}
    }, {
        path: '/hkxjk/:actId',
        component: Hkxjk,
        point: { event_id: "2241951", pageId: 'H1005'}
    }, {
        path: '/recruit/:actId',
        component: Recruit,
        point: { event_id: "2241951", pageId: 'H1005'}
    }, {
        path: '/coupon',
        component: Coupon,
        point: { event_id: "2241951", pageId: 'H1017'}
    }, {
        path: '/signWechat',
        component: SignWechat,
    }
]

export default routers;

